module.exports = __webpack_public_path__ + "static/img/math-symbol1.5c541a97.png";